import { ElementRef, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { AbstractCustomControl } from '../abstract-custom-control';
import { ViewChild } from '@angular/core';
export class BaseInput extends AbstractCustomControl<any>{
    constructor(protected changeDetectorRef: ChangeDetectorRef){
        super(changeDetectorRef);
    }

    @Input() Type: string = 'text';
    @Input() MaxLength: number = 50;
    @Input() Autocomplete: boolean = false;
    @Input() Uppercase: boolean = false;

    @Output() OnValueChange = new EventEmitter();
    @Output() OnKeyDown = new EventEmitter();
    @Output() OnBlur = new EventEmitter();

    @ViewChild('input', { static: true }) inputControl: ElementRef;
    @ViewChild('placeholder', { static: true }) placeholder: ElementRef;
    @ViewChild('errorIcon', { static: true }) errorIcon: ElementRef;
    @ViewChild('clearButton', { static: false }) clearButton: ElementRef;

    ngAfterViewInit(){
        this.setSize();
    }

    ngAfterViewChecked(){
        //this.setSize();
    }

    focus(){
        //console.log('base input focus');
        super.focus();
        let __this = this;
        setTimeout(function(){
            __this.inputControl.nativeElement.focus();
        }, 100);
    }

    Clear(){
        this.value = null;
        this.OnValueChange.emit(null);
        this.focus();
    }

    setSize(){
        if(this.inputControl.nativeElement.offsetWidth > 0){
            //this.placeholder.nativeElement.style.width = this.inputControl.nativeElement.offsetWidth + 'px';
            this.errorIcon.nativeElement.style.left = this.inputControl.nativeElement.offsetWidth - 20 + 'px';
        }
    }

    onInput(value){
        this.OnValueChange.emit(value);
    }

    setDisabledState(isDisabled: boolean){
        super.setDisabledState(isDisabled);
        this.inputControl.nativeElement.disabled = isDisabled;
        this.changeDetectorRef.markForCheck();
        //this.clearButton.nativeElement.disabled = isDisabled;
    }

    writeValue(value){
        super.writeValue(value);
        this.changeDetectorRef.markForCheck();
    }

    keyDown(value){
        this.OnKeyDown.emit(value);
    }

    onFocusOut(target: any) {
        super.onFocusOut(target);
        this.OnBlur.emit(this.value);
    }
}